import { Modal } from 'antd';
import { useIntl } from 'react-intl';

import { ReactComponent as Close } from 'assets/bosta-icons/Close.svg';

import './ViewReceiptModal.less';

const ViewReceiptModal = ({
  receiptLink,
  setIsviewReceiptDisabled,
  visible,
  close,
  ...props
}) => {
  const { formatMessage } = useIntl();
  const handleClose = () => {
    setIsviewReceiptDisabled(false);
    close();
  };
  return (
    <Modal
      width={null}
      visible={visible}
      onCancel={handleClose}
      className="br-view-receipt-modal"
      footer={false}
      title={
        <>
          <span className="heading1">
            {formatMessage({
              id: 'recharge_requests.view_receipt_modal.title'
            })}
          </span>
          <Close onClick={handleClose} />
        </>
      }
    >
      <div className="br-view-receipt-modal__content">
        <img src={receiptLink} alt="Receipt_Image" width={700} />
      </div>
    </Modal>
  );
};

export default ViewReceiptModal;
